<template>
        <div ref="cont" id="pfid1618819542">
        <email-editor ref="emailEditor" :projectId="14970" :options="options" :locale="$i18n.locale" :min-height="minHeight" :style="{ height: minHeight }" @load="editorLoaded" />
        </div>
</template>
<script>

import { EmailEditor } from 'vue-email-editor'
import UnlayerOptions from '@/util/unlayer-options'
import PreviewProducts from '@/util/preview-products'

export default {
    name: 'NewsletterEditor',
    components: {EmailEditor},
    data() {
        let i18n = {
            title: this.$t('newsletters.tools.title'),
            enable: this.$t('newsletters.tools.enable'),
            custom_font: this.$t('newsletters.tools.customFont'),
            font_family: this.$t('newsletters.tools.fontFamily'),
            font_size: this.$t('newsletters.tools.fontSize'),
            color: this.$t('newsletters.tools.color'),
            align: this.$t('newsletters.tools.align'),
            image: this.$t('newsletters.tools.image.title'),
            height: this.$t('newsletters.tools.image.height'),
            height_rows: this.$t('newsletters.tools.name.height'),
            padding_bottom: this.$t('newsletters.tools.paddingBottom'),
            padding_top: this.$t('newsletters.tools.paddingTop'),
            bold: this.$t('newsletters.tools.bold'),
            italics: this.$t('newsletters.tools.italics'),
            underscore: this.$t('newsletters.tools.underscore'),
            linethrough: this.$t('newsletters.tools.linethrough'),
            common: this.$t('newsletters.tools.common'),
            name: this.$t('newsletters.tools.name.title'),
            description: this.$t('newsletters.tools.description.title'),
            price: this.$t('newsletters.tools.price.title'),
            original_price: this.$t('newsletters.tools.originalPrice.title'),
            sale: this.$t('newsletters.tools.sale.title'),
            color_text: this.$t('newsletters.tools.buton.colorText'),
            color_background: this.$t('newsletters.tools.buton.colorBackground'),
            border: this.$t('newsletters.tools.border'),
            button_text: this.$t('newsletters.tools.buton.text'),
            button_text_default: this.$t('webboxes.buttonText'),
            button_width: this.$t('newsletters.tools.buton.width'),
            button_corners: this.$t('newsletters.tools.buton.corners'),
            box_type: this.$t('newsletters.tools.boxType.title'),
            box_rec: this.$t('newsletters.tools.boxType.recommendations'),
            box_new: this.$t('newsletters.tools.boxType.new'),
            box_cat: this.$t('newsletters.tools.boxType.categories'),
            product_category: this.$t('newsletters.tools.boxType.category'),
            mobile_width: this.$t('newsletters.tools.mobileWidth')
            
        }
        return {
            replaceImageUrl: /https:\/\/placehold.co\/200x\d+\/png\?text=PRODUCT\+IMAGE/,///https:\/\/via.placeholder.com\/200x\d+\/[A-F0-9]{6}\/[A-F0-9]{6}\/\?text=[+A-Z]+/,//require('@/assets/product-image-placeholder.svg'),
            i18n,
            options: UnlayerOptions(i18n, this.productCategories),
            suffixes: [
                '',
                '_NEW',
                '_C[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}'
            ]
        }
    },
    props: {
        newsletter: Object,
        campaign: { type: String, required: true },
        height: Number,
        html: String, // this should by used with sync modifier to get the HTML
        text: String,
        preview: String,
        valid: { type: Boolean, default: true },
        unsubscribe: { type: Boolean, default: false },
        specs: Object,
        specsNew: Object,
        specsCategories: Array,
        dnsName: String,
        productCategories: { type: Array, required: true }
    },
    computed: {
        minHeight() {
            //return '900';
            let height = this.height;
            //console.debug('Computing height:')
            if(!height) {
                let vh = Math.max(document.documentElement.clientHeight || 0, window.innerHeight || 0);
                console.debug(!!this.$refs.cont);
                //console.dir(JSON.stringify(this.$refs));
                //console.dir(this.$refs);
                let top = this.$refs.cont?.offsetTop ?? 0;
                //console.debug(`Top: ${top}`);
                height = `${vh - top - 115}px`;
                //console.debug(`vh ${vh} top ${top} height ${height}`);
            } else {
                height = `${this.height}px`;
            }
            return height;
        }
    },
    watch: {
    },
    methods: {
        editorLoaded() {
        // Pass your template JSON here
            this.$refs.emailEditor.editor.registerCallback('image', this.uploadAsset);
            let t = this;
            this.$refs.emailEditor.editor.addEventListener('design:updated', async () => {
                let newsletter = await t.getDesign();
                await t.getTemplate(newsletter);
                t.$emit('save', newsletter);
                t.$emit('update:newsletter', newsletter);
            });
            this.$refs.emailEditor.editor.addEventListener('design:loaded', async () => {
                let newsletter = await t.getDesign();
                await t.getTemplate(newsletter);
                t.$emit('save', newsletter);
                t.$emit('update:newsletter', newsletter);
            });
            this.$refs.emailEditor.editor.registerCallback('previewHtml', (params, done) => {
                //console.debug('preview called!');
                t.getPreview(params.html).then((preview) => done({
                    html: preview
                }))
                
            });
            if(this.newsletter) {
                //console.debug('newsletter', this.newsletter);
                this.$refs.emailEditor.editor.loadDesign(this.newsletter);
            }
            this.getTemplate();
        },
        async uploadAsset(f, done) {
            // original implementation is here

            // omitting firing events, but doing the add through the api
            
            //console.debug(url);
            //console.dir(options);
            //console.dir(options.body.getAll());
            //console.dir(e);
            let file = f.attachments[0];
            //console.dir(file);
            var res = await this.$store.dispatch('campaigns/uploadAsset', { campaign: this.campaign, name: file.name, mime: file.type, file });
            //console.debug(res);
            done({ progress: 100, url: res });
        },

        async getPreview(preview, occurrences) {
            if(!preview) { 
            preview = await new Promise((resolve) => {
                this.$refs.emailEditor.editor.exportHtml(
                    (data) => {
                    //console.debug('exportHtml', data);
                    resolve(data.html);
                    })
            });
            }

            // just to make sure...
            preview = preview.replace(/\{\{\n/g, '{{ ');
            preview = preview.replace(/\n\}\}/g, ' }}');

            if(!occurrences) {
                occurrences = this.expandSuffixes(preview).map(suffix => ({ suffix, occurrences: this.getOccurrences(preview, suffix) }));
            }
            //console.debug(preview);
            // preparing the preview
            //let desc = 'Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Excepteur...';
            // TODO include products from domain
            // TODO adjust the logic for sale/original price display
            let pp = PreviewProducts;
            occurrences.forEach(({suffix, occurrences}) => {
                for(let i = 0; i < occurrences[0]; i++) {
                preview = preview.replace(new RegExp(`\\{\\{ *PRODUCT_NAME${suffix} *\\}\\}`, 'i'), pp[i].name);
                preview = preview.replace(new RegExp(`\\{\\{ *PRODUCT_URL${suffix} *\\}\\}`, 'i'), 'https://dreamroi.com');
                preview = preview.replace(new RegExp(`\\{\\{ *PRODUCT_IMAGE${suffix} *\\}\\}`, 'i'), `${this.$store.getters['ui/baseUrl']}${pp[i].img}` );
                //backwards compatibility with old templates
                preview = preview.replace(this.replaceImageUrl, `${this.$store.getters['ui/baseUrl']}${pp[i].img}` );
                preview = preview.replace(new RegExp(`\\{\\{ *PRODUCT_DESCRIPTION${suffix} *\\}\\}`, 'i'), this.specs?.stripDescription ? pp[i].description.substr(0, this.specs?.stripDescription) : pp[i].description);
                preview = preview.replace(new RegExp(`\\{\\{ *PRODUCT_PRICE${suffix} *\\}\\}`, 'i'), pp[i].price);
                preview = preview.replace(new RegExp(`\\{\\{ *PRODUCT_ORIGINAL_PRICE${suffix} *\\}\\}`, 'i'), (this.specs?.originalPriceTemplate || '{}').replace(/{}/g, pp[i].originalPrice));
                preview = preview.replace(new RegExp(`\\{\\{ *PRODUCT_SALE${suffix} *\\}\\}`, 'i'), (this.specs?.saleTemplate || '-{}%').replace(/{}/g, pp[i].sale));
                preview = preview.replace(new RegExp(`\\{\\{ *PRODUCT_URLIMG${suffix} *\\}\\}`, 'i'), 'https://dreamroi.com');
                preview = preview.replace(new RegExp(`\\{\\{ *PRODUCT_URLBTN${suffix} *\\}\\}`, 'i'), 'https://dreamroi.com');
                preview = preview.replace(new RegExp(`\\{\\{ *PRODUCT_NAMEIMG${suffix} *\\}\\}`, 'i'), pp[i].name);
            }
            });
            
            /*
            for(let i = 0; i < count; i++) {
                preview = preview.replace(/\{\{ *PRODUCT_NAME_NEW *\}\}/i, pp[i].name);
                preview = preview.replace(/\{\{ *PRODUCT_URL_NEW *\}\}/i, 'https://dreamroi.com');
                preview = preview.replace(this.replaceImageUrl, `${this.$store.getters['ui/baseUrl']}${pp[i].img}` );
                preview = preview.replace(/\{\{ *PRODUCT_DESCRIPTION_NEW *\}\}/i, this.specs?.stripDescription ? pp[i].description.substr(0, this.specs?.stripDescription) : pp[i].description);
                preview = preview.replace(/\{\{ *PRODUCT_PRICE_NEW *\}\}/i, pp[i].price);
                preview = preview.replace(/\{\{ *PRODUCT_ORIGINAL_PRICE_NEW *\}\}/i, (this.specs?.originalPriceTemplate || '{}').replace(/{}/g, pp[i].originalPrice));
                preview = preview.replace(/\{\{ *PRODUCT_SALE_NEW *\}\}/i, (this.specs?.saleTemplate || '-{}%').replace(/{}/g, pp[i].sale));
                preview = preview.replace(/\{\{ *PRODUCT_URLIMG_NEW *\}\}/i, 'https://dreamroi.com');
                preview = preview.replace(/\{\{ *PRODUCT_URLBTN_NEW *\}\}/i, 'https://dreamroi.com');
                preview = preview.replace(/\{\{ *PRODUCT_NAMEIMG_NEW *\}\}/i, pp[i].name);
            }
            for(let i = 0; i < count; i++) {
                preview = preview.replace(/\{\{ *PRODUCT_NAME_C[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12} *\}\}/i, pp[i].name);
                preview = preview.replace(/\{\{ *PRODUCT_URL_C[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12} *\}\}/i, 'https://dreamroi.com');
                preview = preview.replace(this.replaceImageUrl, `${this.$store.getters['ui/baseUrl']}${pp[i].img}` );
                preview = preview.replace(/\{\{ *PRODUCT_DESCRIPTION_C[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12} *\}\}/i, this.specs?.stripDescription ? pp[i].description.substr(0, this.specs?.stripDescription) : pp[i].description);
                preview = preview.replace(/\{\{ *PRODUCT_PRICE_C[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12} *\}\}/i, pp[i].price);
                preview = preview.replace(/\{\{ *PRODUCT_ORIGINAL_PRICE_C[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12} *\}\}/i, (this.specs?.originalPriceTemplate || '{}').replace(/{}/g, pp[i].originalPrice));
                preview = preview.replace(/\{\{ *PRODUCT_SALE_C[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12} *\}\}/i, (this.specs?.saleTemplate || '-{}%').replace(/{}/g, pp[i].sale));
                preview = preview.replace(/\{\{ *PRODUCT_URLIMG_C[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12} *\}\}/i, 'https://dreamroi.com');
                preview = preview.replace(/\{\{ *PRODUCT_URLBTN_C[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12} *\}\}/i, 'https://dreamroi.com');
                preview = preview.replace(/\{\{ *PRODUCT_NAMEIMG_C[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12} *\}\}/i, pp[i].name);
            }
            */
            this.$emit('update:preview', preview);
            return preview;
        },

        expandSuffixes(html) {
            let output = [];
            this.suffixes.forEach(s => {
                return ['url','image','name','urlimg', 'urlbtn', 'description','sale','price', 'nameimg', 'image_contain', 'nameimgc', 'original_price'].forEach((field) => {
                    let re = new RegExp(`\\{\\{ *PRODUCT_${field.toUpperCase()}(${s}) *\\}\\}`, 'gi');
                    //console.dir(re);
                    let matches = html.matchAll(re);
                    for(let match of matches) {
                        let suffix = match[1];
                        if(!output.includes(suffix)) {
                            output.push(suffix);
                        }
                    }
                });
            });
            console.debug('expanded suffixes', output);
            return output;
        },

        getOccurrences(html, suffix = '') {
            return ['url','image','name','urlimg', 'urlbtn', 'description','sale','price', 'nameimg', 'image_contain', 'nameimgc', 'original_price'].map((field) => {
                let re = new RegExp(`\\{\\{ *PRODUCT_${field.toUpperCase()}${suffix} *\\}\\}`, 'gi');
                //console.dir(re);
                let m = html.match(re);
                //console.dir(m);
                // returns number of matches
                return m ? m.length : 0;
            });
        },

        async validate(html, occurrencesAll) {
            if(!html) {
                html = await this.getHTML();
            }
            if(!occurrencesAll) {
                occurrencesAll = this.expandSuffixes(html).map(suffix => ({ suffix, occurrences: this.getOccurrences(html, suffix) }));
            }

            const m = (i) => {
                let m = 1;
                // button or image
                if(i == 4 || i == 8 || i == 10) {
                    m = 2;
                }
                return m;
            }

            let result = true;
            let macroCountAll = [];
            occurrencesAll.forEach(({suffix, occurrences}) => {
            // check maximum number of 10 occurences
            console.debug(`Checking occurrences for suffix ${suffix}`, occurrences);
            result = result && occurrences.every((val,i) => {
                return val <= m(i) * 10;
            });
            // each products box hopefully contants product name or image
            macroCountAll.push(Math.max(occurrences[0], occurrences[1]));
            let macroCount = macroCountAll[macroCountAll.length - 1];
            for(let i = 1; i < occurrences.length; i++) {
                if(macroCount == 0 && occurrences[i] != 0) {
                    macroCount = occurrences[i] / m(i);
                } else if(occurrences[i] != 0 && macroCount != (occurrences[i] / m(i))) {
                    console.debug(`Macro count does not match! curr ${occurrences[i] / m(i)} glob ${macroCount} for suffix ${suffix}`);
                    result = false;
                }
            }
            console.debug('macroCount', suffix, macroCount, macroCountAll[macroCountAll.length - 1]);
            });
            //console.dir(occurrences);
            // all item is the occurrences array must be the same
            this.$emit('update:valid',  result);
            this.$emit('update:unsubscribe', /href="\{\{ *UNSUBSCRIBE *\}\}"/i.test(html));
            return macroCountAll;
        },

        getRecommendationsCount(html, suffix = '') {
            // either product name or product image will be present
            let matches = html.matchAll(new RegExp(`\\{\\{ *PRODUCT_URLI?M?G?${suffix}_(\\d+) *\\}\\}`, 'gi'));
            //console.debug('Rec count matches:', html, matches);
            let max = -1;
            for(let match of matches) {
                var index = parseInt(match[1]);
                if(index > max) {
                    max = index;
                }
            }
            // returning count
            return max+1;
        }, 

        // https://stackoverflow.com/questions/3446170/escape-string-for-use-in-javascript-regex
        escapeRegExp(string) {
            return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'); // $& means the whole matched string
        },

        async getHTML() {
            let html = await new Promise((resolve) => {
                this.$refs.emailEditor.editor.exportHtml(
                    (data) => {
                    //console.debug('exportHtml', data);
                    resolve(data.html);
                    })
            });
            
            // just to make sure...
            html = html.replace(/\{\{\n/g, '{{ ');
            html = html.replace(/\n\}\}/g, ' }}');

            // first replace the image placeholders
            
            // this is not needed, we can edit the exporter
            //html = html.replace(new RegExp(this.replaceImageUrl, 'g'),'{{ PRODUCT_IMAGE }}');
            return html;
        },

        async getText() {
            let text = await new Promise((resolve) => {
                this.$refs.emailEditor.editor.exportPlainText(
                    (data) => {
                    //console.debug('exportPlaintext', data);
                    resolve(data.text);
                    })
            });
            
            // first replace the image placeholders
            
            // this is not needed, we can edit the exporter
            //text = text.replace(new RegExp(`${this.replaceImageUrl}`, 'g'),'{{ PRODUCT_IMAGE }}');
            
            // Unlayer seems to insert endline into handlebars expressions when too long:
            // {{\nPRODUCT_SALE_C1e16962d-2051-49f8-aa6a-35d50bbd0290 }}
            text = text.replace(/\{\{\n/g, '{{ ');
            text = text.replace(/\n\}\}/g, ' }}');
            console.debug('text template', text);
            return text;
        },
        /*
        updateNewsletter(nsltr) {
            this.$emit('save',nsltr);
            // https://github.com/artf/grapesjs-mjml/issues/2
            this.getTemplate();
        },
        */
       replaceMacros(template, suffix, macroCount) {
           // modify the code - index the macros
            for(let i = 0; i < macroCount; i++) {
                ['image', 'image_contain', 'name', 'url','description','sale','price', 'original_price'].forEach((field) => {
                    let re = new RegExp(`\\{\\{ *PRODUCT_${field.toUpperCase()}${suffix} *\\}\\}`, 'i');
                    template = template.replace(re, `{{ PRODUCT_${field.toUpperCase()}${suffix}_${i} }}`);
                });
                template = template.replace(new RegExp(`\\{\\{ *PRODUCT_URLIMG${suffix} *\\}\\}`, 'i'), `{{ PRODUCT_URL${suffix}_${i} }}`);
                //template = template.replace(/\{\{ *PRODUCT_URLIMGC *\}\}/i, `{{ PRODUCT_URL_${i} }}`);
                // buttons are generated twice in the generated template - two links are together
                template = template.replace(new RegExp(`\\{\\{ *PRODUCT_URLBTN${suffix} *\\}\\}`, 'i'), `{{ PRODUCT_URL${suffix}_${i} }}`);
                template = template.replace(new RegExp(`\\{\\{ *PRODUCT_URLBTN${suffix} *\\}\\}`, 'i'), `{{ PRODUCT_URL${suffix}_${i} }}`);
                template = template.replace(new RegExp(`\\{\\{ *PRODUCT_NAMEIMG${suffix} *\\}\\}`, 'i'), `{{ PRODUCT_NAME${suffix}_${i} }}`);
                template = template.replace(new RegExp(`\\{\\{ *PRODUCT_NAMEIMG${suffix} *\\}\\}`, 'i'), `{{ PRODUCT_NAME${suffix}_${i} }}`);
                template = template.replace(new RegExp(`\\{\\{ *PRODUCT_NAMEIMGC${suffix} *\\}\\}`, 'i'), `{{ PRODUCT_NAME${suffix}_${i} }}`);
                template = template.replace(new RegExp(`\\{\\{ *PRODUCT_NAMEIMGC${suffix} *\\}\\}`, 'i'), `{{ PRODUCT_NAME${suffix}_${i} }}`);
            }
            return template;
       },

        addTracking(template) {
            // modify the code - add tracking pixel
            template = template.replace('</body>', `<img src="${this.$store.getters['ui/pixelUrl']}" alt=""></body>`)

            /* eslint-disable no-useless-escape */
            // regex for html
            template = this.addUTM(template, /(href=")((http(s)?:\/\/.)?(www\.)?[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*))(")/ig);
            // regex for text
            template = this.addUTM(template, /(\n)((http(s)?:\/\/.)?(www\.)?[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*))(\n)/ig);
            /* eslint-enable no-useless-escape */
            return template;
        },

        addUTM(template, regex) {
            // add UTM parameters to all links
            // test UTMs
            // find all a href tags without macros
            // regex for url: (http(s)?:\/\/.)?(www\.)?[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)
            /* eslint-disable no-useless-escape */
            //let links = html.matchAll(/href=\"((http(s)?:\/\/.)?(www\.)?[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*))\"/ig);
            //
            /* not working correctly - replacing also a img src when image is clickable
            let links = template.matchAll(regex);
            
            //console.dir(links);
            
            for(let match of links) {
                //console.dir(match);
                let link = match[1];
                
                let firstChar = '?';
                if(link.indexOf('?') > -1) {
                    firstChar = '&';
                }
                //template = template.replace(link, `${link}${firstChar}utm_source={{UTM_SOURCE}}&utm_campaign={{UTM_CAMPAIGN}}&utm_medium={{UTM_MEDIUM}}&droicmpid={{CAMPAIGN_ID}}`);
                template = template.replace(link, `http://dreamroi-tr.${this.dnsName}/click/message/{{MESSAGE_ID}}?url=${encodeURIComponent(`${link}${firstChar}`)}utm_source%3D{{UTM_SOURCE}}%26utm_campaign%3D{{UTM_CAMPAIGN}}%26utm_medium%3D{{UTM_MEDIUM}}%26droicmpid%3D{{CAMPAIGN_ID}}`)
            }*/
            //https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/replace
            template = template.replace(regex, (match, before, link, http, https, www, path, after) => {
                //console.debug(`${match} ${before} ${link} ${http} ${https} ${www} ${path} ${after}`);

                let firstChar = '?';
                if(link.indexOf('?') > -1) {
                    firstChar = '&';
                }
                return `${before}https://dreamroi-tr.${this.dnsName}/click/message/{{MESSAGE_ID}}?url=${encodeURIComponent(`${link}${firstChar}`)}utm_source%3D{{UTM_SOURCE}}%26utm_campaign%3D{{UTM_CAMPAIGN}}%26utm_medium%3D{{UTM_MEDIUM}}%26droicmpid%3D{{CAMPAIGN_ID}}${after}`;
            })

            return template;
        },

        getDesign() {
            return new Promise((resolve) => {
                this.$refs.emailEditor.editor.saveDesign(
                    (design) => {
                        console.debug('saveDesign', design);
                        resolve(design);
                    }
                )
            });
        },

        fillSpecs(html, suffix = '') {
            // copy the price, sale templates from the recommendation specs
            let specs = Object.assign({}, this.specs); 
            specs.recommendationsCount = this.getRecommendationsCount(html, suffix),
                /*
                name: /\{\{ *PRODUCT_NAME_\d+ *\}\}/i.test(html),
                price: /\{\{ *PRODUCT_PRICE_\d+ *\}\}/i.test(html),
                image: /\{\{ *PRODUCT_IMAGE_\d+ *\}\}/i.test(html),
                sale: /\{\{ *PRODUCT_SALE_\d+ *\}\}/i.test(html),
                description: /\{\{ *PRODUCT_DESCRIPTION_\d+ *\}\}/i.test(html),,
                */
            
            ['image','name','description','sale','price'].forEach((field) => {
                specs[field] = new RegExp(`\\{\\{ *PRODUCT_${field.toUpperCase()}${suffix}_\\d+ *\\}\\}`, 'i').test(html);
            });
            specs.originalPrice = new RegExp(`\\{\\{ *PRODUCT_ORIGINAL_PRICE${suffix}_\\d+ *\\}\\}`, 'i').test(html);
            return specs;
        },

        async getTemplate(newsletter) {
            if(!newsletter) {
                newsletter = await this.getDesign();
            }

            let html = await this.getHTML();
            let suffixes = this.expandSuffixes(html);

            // check equal number of macros
            //console.dir(html);
            let occurrences = suffixes.map(suffix => ({ suffix, occurrences: this.getOccurrences(html, suffix) }));

            console.debug('occurences', occurrences);
            // must be called before index replacements
            let macroCount = await this.validate(html, occurrences);

            suffixes.forEach((s,i) => {
                html = this.replaceMacros(html, s, macroCount[i]);
            });
            

            let text = await this.getText();
            suffixes.forEach((s,i) => {
                text = this.replaceMacros(text, s, macroCount[i]);
            });
            html = this.addTracking(html);
            text = this.addTracking(text);
            //console.debug(html);
            this.$emit('update:html', html);
            this.$emit('update:text', text);
            // udpate the template specs
            
            let specs = this.fillSpecs(html);
            
            this.$emit('update:specs', specs);
            let specsNew = this.fillSpecs(html, this.suffixes[1]);
            this.$emit('update:specsNew', specsNew);

            let categories = occurrences.filter(s => s.suffix.startsWith('_C')).map(s => ({ productCategoryID: s.suffix.substring(2), specs: this.fillSpecs(html, s.suffix) }));
            this.$emit('update:specsCategories', categories);


            await this.getPreview(null, occurrences);
            return {
                newsletter,
                html,
                text,
                preview: this.preview,
                specs
            }
        }
    },
   
    async mounted() {
    }
}
</script>